import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserExtra from './user-extra';
import ForeignerResidence from './foreigner-residence';
import ForeignerResidenceReport from './foreigner-residence/foreigner-residence-report';
/* jhipster-needle-add-route-import - JHipster will add routes here */

export default () => {
  return (
    <div>
      <ErrorBoundaryRoutes>
        {/* prettier-ignore */}
        <Route path="user-extra/*" element={<UserExtra />} />
        <Route path="foreigner-residence/*" element={<ForeignerResidence />} />
        <Route path="foreigner-residence-report/*" element={<ForeignerResidenceReport />} />
        {/* jhipster-needle-add-route-path - JHipster will add routes here */}
      </ErrorBoundaryRoutes>
    </div>
  );
};
